/** @jsxImportSource @emotion/react */
import { ReactComponent as Stars } from "@/assets/img/estrellas.svg";
import NovaventaButton from "@/components/formControls/button/NovaventaButton";
import ModalMessage from "@/components/ModalMessage";
import { usePrismic } from "@/hooks/usePrismic";
import { WelcomeContainer } from "@/pages/WelcomeToNovaventa";
import { validarCupoDemanda } from "@/services/cashToCredit";
import { errorDictionary } from "@/utils/hooks/HandleHttpErrors";
import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router";

export const CreditOnDemand = () => {
  const { ciclo, data } = useParams();
  const [isValid, setIsValid] = useState<boolean>();
  const [modalBtnText, setModalBtnText] = useState("");
  const [modalTittle, setModalTittle] = useState("");
  const [modalTextModal, setModalTextModal] = useState("");
  const [newCupo, setNewCupo] = useState("");
  const t = usePrismic();

  const linkCommerce = process.env.REACT_APP_URL_COMMERCE;

  useEffect(() => {
    validarCupoDemanda({ data, ciclo })
      .then((res) => {
        if (res.continuar) {
          setIsValid(true);
          setNewCupo(res.body);
        } else {
          setIsValid(false);
          setModalTextModal(errorDictionary(`MSGB${res.codigo}`, t.errors));
          setModalBtnText(errorDictionary(`BTN${res.codigo}`, t.errors));
          setModalTittle(errorDictionary(`ART${res.codigo}`, t.errors));
        }
      })
      .catch(console.error);
  }, []);

  const redirect = () => {
    window.location.assign(String(linkCommerce));
  };

  if (isValid && newCupo) {
    const formatter = new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0
    });

    return (
      <WelcomeContainer>
        <Row align="middle" justify="center">
          <Col xs={0} md={23}>
            <Stars />
          </Col>

          <Col xs={23}>
            <h1>
              {t.constants.wasExpanded.split(">|<")[0]}
              <b>{t.constants.wasExpanded.split(">|<")[1]}</b>
            </h1>
            <p>
              {t.constants.youHaveQuota.split("${0}")[0]}
              <b>{formatter.format(Number(newCupo))}</b>
              {t.constants.youHaveQuota.split("${0}")[1]}
            </p>
          </Col>

          <Col xs={20} sm={18} md={14} lg={10} xl={7}>
            <NovaventaButton
              handleClick={redirect}
              htmlType="submit"
              btnText={t.constants.INICIOSESIONOFICINA}
            />
          </Col>
        </Row>
      </WelcomeContainer>
    );
  }

  if (isValid === false) {
    return (
      <ModalMessage
        showModal={true}
        alertText={modalTittle}
        text={modalTextModal}
        btnText={modalBtnText}
        kind="error"
        handleClickBtn={redirect}
      />
    );
  }

  return <></>;
};
